import { gql } from 'urql';

export const GET_ASSET_REGION_INFO = gql`
    query AssetRegion($assetRegionUUID: uuid!) {
        asset: regions_asset_regions_by_pk(uuid: $assetRegionUUID) {
            stack: nom_stack
            uuid
            geometry
            inverterId: inverter_id
            combinerId: combiner_id
            inverterIdBackup: nom_properties(path: "cref_inverter_id")
            combinerIdBackup: nom_properties(path: "cref_combiner_id")
            inverterIdBackup2: nom_properties(path: "inverter_id")
            combinerIdBackup2: nom_properties(path: "combiner_id")
            inverterIdBackup3: nom_properties(path: "['Inverter ID']")
            combinerIdBackup3: nom_properties(path: "['Combiner ID']")
            positionId: nom_properties(path: "['Position ID']")
            serialNumber: nom_properties(path: "serial_number")
        }
    }
`;
